// Side by Side - Email Form & Onboarding Modal
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-side-by-side-section]');

  // Bot trap: honeypot + time-trap. Mirrors waitlist-form.liquid. Submits with
  // the honeypot filled, or fired within 1.5s of page load, are bot speed and
  // are silently dropped before any Klaviyo identify/track call.
  const formLoadTs = Date.now();

  sections.forEach(function (section) {
    // === EMAIL FORM FUNCTIONALITY ===
    const emailForm = section.querySelector('[data-email-form]');
    const emailInput = section.querySelector('[data-side-by-side-email-input]');

    function looksLikeBot() {
      try {
        const hp = emailForm ? emailForm.querySelector('input[name="bp_website"]') : null;
        if (hp && hp.value && hp.value.trim() !== '') return true;
        if (Date.now() - formLoadTs < 1500) return true;
        return false;
      } catch (_) {
        return false;
      }
    }

    if (emailForm) {
      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();

        // Honeypot / time-trap: silently drop bot submits.
        if (looksLikeBot()) {
          try { emailForm.reset(); } catch (_) {}
          return;
        }

        const email = emailInput ? emailInput.value.trim() : '';

        // Clarity <-> Klaviyo identity link: tag this session with the email as
        // Clarity's Custom User ID. Runs independent of Klaviyo so it fires even
        // if Klaviyo is blocked. Strong signal (deliberate submit) -> persist.
        if (email && email.includes('@')) {
          try { if (window.brClarityIdentify) window.brClarityIdentify(email, true); } catch (error) {}
        }

        // Fire Klaviyo "Started Onboarding (General)" event
        if (email && typeof klaviyo !== 'undefined') {
          try {
            klaviyo.identify({ '$email': email });
            setTimeout(() => {
              try {
                klaviyo.track('Started Onboarding (General)', {
                  '$email': email,
                  form_location: 'side-by-side',
                  page_url: window.location.href,
                  timestamp: new Date().toISOString()
                });
              } catch (error) {}
            }, 500);
          } catch (error) {}
        }

        // Open onboarding modal
        if (typeof window.openB2BOnboardingModal === 'function') {
          window.openB2BOnboardingModal();

          // Pre-populate email if provided
          if (email) {
            // Wait for modal to open and DOM to be ready
            setTimeout(() => {
              const onboardingEmailInput = document.querySelector(
                '#b2bOnboardingModal input[type="email"], #b2bOnboardingModal input[name="email"]'
              );

              if (onboardingEmailInput) {
                onboardingEmailInput.value = email;
                // Trigger input event for any listeners
                onboardingEmailInput.dispatchEvent(new Event('input', { bubbles: true }));
                onboardingEmailInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }, 300);
          }
        } else {
          console.warn('Onboarding modal function not found. Make sure the onboarding section is included on the page.');
        }
      });
    }

    // === ONBOARDING MODAL BUTTONS ===
    const onboardingButtons = section.querySelectorAll('[data-open-onboarding="true"]');
    onboardingButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        if (typeof window.openB2BOnboardingModal === 'function') {
          window.openB2BOnboardingModal();
        } else {
          console.warn('Onboarding modal function not found');
        }
      });
    });
  });
});
